import React from "react";
import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";
import HandymanIcon from "@mui/icons-material/Handyman";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import { motion } from "framer-motion";

const HomeCover_Boxes = () => {
  const boxVariants = {
    left: {
      hidden: { opacity: 0, x: -60 },
      visible: { opacity: 1, x: 0 },
    },
    bottom: {
      hidden: { opacity: 0, y: 60 },
      visible: { opacity: 1, y: 0 },
    },
    right: {
      hidden: { opacity: 0, x: 60 },
      visible: { opacity: 1, x: 0 },
    },
  };

  return (
    <Box sx={{ py: 8, backgroundColor: "#f8f8f8", marginBottom: "80px" }}>
      <Container maxWidth="lg" sx={{ position: "relative" }}>
        <Grid
          container
          sx={{
            flexWrap: {
              xs: "wrap", // flex wrap on small screens
              md: "nowrap",
              lg: "nowrap", // no wrap on large screens
            },
            display: "flex",
            position: "absolute",
            top: "-110px",
            zIndex: "9",
          }}
        >
          {/* BOX 1 */}
          <Grid item xs={12} sm={6} md={4} className="threeBoxes">
            <motion.div
              variants={boxVariants.left}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
            >
              <Paper className="paper" elevation={0}>
                <HomeWorkIcon sx={{ fontSize: 50, color: "#f5b60a" }} />

                <Typography variant="h6" sx={{ fontWeight: 700, mt: 2 }}>
                  Sustainable Supply System
                </Typography>

                <Typography
                  variant="body2"
                  sx={{ mt: 1, whiteSpace: "normal", lineHeight: 1.5 }}
                >
                  We ensure responsible sourcing and efficient distribution of construction materials, maintaining quality while minimizing environmental impact across large-scale infrastructure projects.
                </Typography>
              </Paper>
            </motion.div>
          </Grid>

          {/* BOX 2 (YELLOW CENTER BOX) */}
          <Grid item xs={12} sm={6} md={4} className="threeBoxes">
            <motion.div
              variants={boxVariants.bottom}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, ease: "easeOut", delay: 0.15 }}
            >
              <Paper
                className="paper"
                elevation={0}
                sx={{
                  textAlign: "left",
                  bgcolor: "#f5b60a",
                  height: "100%",
                }}
              >
                <Diversity3Icon sx={{ fontSize: 50, color: "#fff" }} />

                <Typography variant="h6" sx={{ fontWeight: 700, mt: 2 }}>
                Quality Materials & Logistics
                </Typography>

                <Typography
                  variant="body2"
                  sx={{ mt: 1, whiteSpace: "normal", lineHeight: 1.5 }}
                >
                  From sand and aggregates to bricks and bulk supplies, we deliver certified materials with reliable logistics support for highways, residential projects, and commercial developments.
                </Typography>
              </Paper>
            </motion.div>
          </Grid>

          {/* BOX 3 */}
          <Grid item xs={12} sm={6} md={4} className="threeBoxes">
            <motion.div
              variants={boxVariants.right}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, ease: "easeOut", delay: 0.3 }}
            >
              <Paper className="paper" elevation={0}>
                <HandymanIcon sx={{ fontSize: 50, color: "#f5b60a" }} />

                <Typography variant="h6" sx={{ fontWeight: 700, mt: 2 }}>
                Infrastructure & Project Expertise
                </Typography>

                <Typography
                  variant="body2"
                  sx={{ mt: 1, whiteSpace: "normal", lineHeight: 1.5 }}
                >
                  With experience supplying to national highways and large construction sites, we understand project timelines, volume requirements, and on-site delivery precision.
                </Typography>
              </Paper>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HomeCover_Boxes;
